import { render } from "./MobileJamakkol.vue?vue&type=template&id=049feaa8&scoped=true"
import script from "./MobileJamakkol.vue?vue&type=script&lang=js"
export * from "./MobileJamakkol.vue?vue&type=script&lang=js"

import "./MobileJamakkol.vue?vue&type=style&index=0&id=049feaa8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049feaa8"]])

export default __exports__